export default "__VITE_ASSET__DpIDeSmI__"